import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { ClientNotifier} from "../../scripts/ah.mb.client-notifications";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { IUserAccount } from "../../infrastructure/userAccount";


@Component
export default class EditUserDialog extends Vue {

    @Prop()
    userName: string;


    private userNotifier = new ClientNotifier();

    value: IUserAccount = {

        confirmPassword: "",
        email: "",
        firstName: "",
        isApproved: true,
        lastName: "",
        password: "",
        roles: "",
        username: "",
        isConfirmed: true,
        userGroups: []
    };


    @Watch("userName")
    userNameChanged(newVal: string) {
        if (newVal) {
            FetchWrapper.typedFetch<IUserAccount>(`/accounts/getuser/${newVal}`, { method: "get" })
                .then(response => response.json())
                .then(response => { this.value = response });
        }

    }

    mounted() {
    }



    //saveUser() {
    //    {
    //        var notification = this.userNotifier.showNotification("Saving user...", true, true);

    //        // var form = $('form#createUserForm').serialize();

    //        const request = {
    //            method: "post",
    //            body: JSON.stringify(this.value),
    //        };

    //        FetchWrapper.sendCommandAndHandle("/accounts/edit", request)
    //            .then(data => {

    //                if (data.success)
    //                    this.value = {
    //                        confirmPassword: "",
    //                        email: "",
    //                        firstName: "",
    //                        isEnabled: true,
    //                        lastName: "",
    //                        password: "",
    //                        roles: "",
    //                        userName: ""
    //                    };

    //            }).then(() => {
    //                this.userNotifier.clear(notification);
    //                this.$emit("dialogClosed", "ok");

    //            });

    //    }
    //}


    saveUser(value: IUserAccount) {
        {
            var notification = this.userNotifier.showNotification("Saving user...", true, true);

           // var form = $('form#createUserForm').serialize();

            const request = {
                method: "post",
                body: JSON.stringify(value),
            };

            FetchWrapper.sendCommandAndHandle(`/accounts/${value.username}/edit`, request)
                
                .then(data => {
                    this.userNotifier.clear(notification);
                    return data;
                }).then(data => {

                    if (data.success)
                        this.$emit("dialogClosed", "ok");

                });
        }
    }

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/accounts/edit-user-dialog.ts